import React, { useEffect, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import GuestPayerDetailSections from './GuestPayerDetailSections';
import { SEARCH_PATH } from '../paths';

const GuestPayerDetail = () => {
  const { number } = useParams();
  const history = useHistory();
  const context = useMemo(() => {
    const getStored = (key) =>
      localStorage.getItem(key) || sessionStorage.getItem(key);
    const storedNumber = getStored('guestLoanNumber');
    const storedType = getStored('guestLoanType');
    const validType =
      storedType && storedType !== 'undefined' && storedType !== 'null'
        ? storedType
        : null;
    if (number === 'unknown') {
      return storedNumber && validType
        ? { number: storedNumber, type: validType }
        : null;
    }
    return {
      number,
      type: String(storedNumber) === String(number) ? validType : null,
    };
  }, [number]);

  useEffect(() => {
    if (number === 'unknown' && context) {
      history.replace({
        pathname: `/service/guest/${context.number}`,
        search: history.location.search,
        state: { add: true },
      });
    }
  }, [context, history, number]);

  if (!context) {
    return (
      <div role="status">
        <p>
          This guest profile is unavailable. Please search for the loan again.
        </p>
        <button type="button" onClick={() => history.push(SEARCH_PATH)}>
          Back to Guest Search
        </button>
      </div>
    );
  }
  if (number === 'unknown') return null;

  return (
    <div>
      <GuestPayerDetailSections
        loanNumber={context.number}
        loanType={context.type}
      />
    </div>
  );
};

export default GuestPayerDetail;
